import React from 'react';
import { btnStyle } from '../../styles/theme';
import { WEAPON_TYPES, WEAPON_QUALITIES, WEAPON_ABILITIES, RANGED_SUBTYPES } from '../../data/weapons';

function WeaponEditor({ weapon, character, setCharacter, idx }) {
  function updateWeapon(updates) {
    const newWeapons = [...(character.weapons || [])];
    newWeapons[idx] = { ...weapon, ...updates };
    setCharacter({ ...character, weapons: newWeapons });
  }

  function deleteWeapon() {
    const newWeapons = character.weapons.filter((_, i) => i !== idx);
    setCharacter({ ...character, weapons: newWeapons });
  }

  const weaponType = WEAPON_TYPES.find(t => t.id === weapon.type);
  const qualities = WEAPON_QUALITIES[weapon.type] || [];
  const qualityData = qualities.find(q => q.id === weapon.quality);
  const abilityData = WEAPON_ABILITIES.find(a => a.id === weapon.ability);

  return (
    <div style={{ background: "rgba(20,16,10,0.6)", border: "1px solid rgba(201,168,76,0.2)", borderRadius: 8, padding: "14px 16px", marginBottom: 10 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, marginBottom: 10 }}>
        <input
          value={weapon.name}
          onChange={(e) => updateWeapon({ name: e.target.value })}
          placeholder="Weapon Name"
          style={{
            background: "rgba(0,0,0,0.3)",
            border: "1px solid rgba(201,168,76,0.3)",
            borderRadius: 4,
            padding: "6px 10px",
            color: "#c9a84c",
            fontFamily: "'Cinzel', serif",
            fontSize: "14px"
          }}
        />
        <button onClick={deleteWeapon} style={{ ...btnStyle("#c0392b", "transparent"), padding: "6px 12px" }}>Delete</button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8 }}>
        {/* Weapon Type */}
        <div>
          <label style={{ fontSize: "9px", color: "#6b6048", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Type</label>
          <select value={weapon.type} onChange={(e) => updateWeapon({ type: e.target.value, quality: "simple", rangedSubtype: e.target.value === "ranged" ? "shortbow" : null })}
            style={{ width: "100%", background: "rgba(0,0,0,0.4)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 4, padding: "6px 8px", color: "#e8dcc8", fontSize: "12px" }}>
            {WEAPON_TYPES.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>

        {/* Quality */}
        <div>
          <label style={{ fontSize: "9px", color: "#6b6048", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Quality</label>
          <select value={weapon.quality} onChange={(e) => updateWeapon({ quality: e.target.value })}
            style={{ width: "100%", background: "rgba(0,0,0,0.4)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 4, padding: "6px 8px", color: "#e8dcc8", fontSize: "12px" }}>
            {qualities.map(q => <option key={q.id} value={q.id}>{q.name}</option>)}
          </select>
        </div>

        {/* Ranged Subtype (only for ranged weapons) */}
        {weapon.type === "ranged" && (
          <div>
            <label style={{ fontSize: "9px", color: "#6b6048", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Bow Type</label>
            <select value={weapon.rangedSubtype || "shortbow"} onChange={(e) => {
              const subtype = RANGED_SUBTYPES.find(s => s.id === e.target.value);
              updateWeapon({ rangedSubtype: e.target.value, ability: subtype.ability });
            }}
              style={{ width: "100%", background: "rgba(0,0,0,0.4)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 4, padding: "6px 8px", color: "#e8dcc8", fontSize: "12px" }}>
              {RANGED_SUBTYPES.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
        )}

        {/* Weapon Ability (not for ranged - they get it from subtype) */}
        {weapon.type !== "ranged" && (
          <div>
            <label style={{ fontSize: "9px", color: "#6b6048", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Ability</label>
            <select value={weapon.ability} onChange={(e) => updateWeapon({ ability: e.target.value })}
              style={{ width: "100%", background: "rgba(0,0,0,0.4)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 4, padding: "6px 8px", color: "#e8dcc8", fontSize: "12px" }}>
              {WEAPON_ABILITIES.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          </div>
        )}
      </div>

      {/* Weapon Info Display */}
      <div style={{ marginTop: 10, padding: "8px 10px", background: "rgba(201,168,76,0.05)", borderRadius: 4, border: "1px solid rgba(201,168,76,0.15)" }}>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: "11px", color: "#a08d4e" }}>
          <div><strong style={{ color: "#c9a84c" }}>Damage:</strong> {qualityData?.damage || "—"}</div>
          <div><strong style={{ color: "#c9a84c" }}>Stat:</strong> {weaponType?.stat} ({qualityData?.statMin || 0}+ required)</div>
          <div><strong style={{ color: "#c9a84c" }}>Skill:</strong> {weaponType?.skill}</div>
          {abilityData && abilityData.id !== "none" && (
            <div style={{ flex: "1 1 100%" }}><strong style={{ color: "#c9a84c" }}>Ability:</strong> {abilityData.desc}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default WeaponEditor
